module.exports = __webpack_public_path__ + "media/images/countrysquared/br-b5820d4027cd0e7b665173464e3a2013.svg";